export enum MediaQueries {
    HEIGHT_GREATER_THAN_420PX = "(min-height: 420px)", // used for a11y (limited height when zoomed it)
}
